import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=a00cb91a&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=a00cb91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00cb91a",
  null
  
)

export default component.exports